import React, { useState, useEffect } from "react";
import { _mlLicensingUserGroupPermission } from "redux/Types";
import clsx from "clsx";
import { MenuItem, Select, TextField } from "@material-ui/core";
import { getCFGroups } from "../../../../redux/actions/MlLicFormContentActions";
import { _PermittedContent } from "_module/utils/PermittedContent";
import { Autocomplete } from "@material-ui/lab";

export default function CfGroupQuestions({
  classes,
  cf,
  onChange,
  field,
  createOrEdit,
  props,
  onChangeLoading,
  readOnlyList,
}) {

  const {
    // classes,
    posting,
  } = props;

  const [cfTypeGroups, setCfFormTypeGroups] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [disableSelect, setDisableSelect] = useState(false);


  useEffect(() => {
    if (isLoading && field && field.groupType) {
      onChangeLoading(isLoading);
      async function fetchCfGroups() {
        let resutls = await getCFGroups(field.groupType, createOrEdit, cf.clearanceFormType);
        if (field.options?.length > 0 && resutls && Array.isArray(resutls) && resutls.length > 0 && createOrEdit === 'create' && onChange) {
          let options = field.options ?? [];
          options = options.filter(o => { return resutls.map(g => g.externalRefId).includes(o.value) });
          if (options.length > 0) {
            let val = cf[field.id] ? cf[field.id] : options[0].value;
            onChange(field.id, val, field.resetForm);
          }
        }
        setCfFormTypeGroups(resutls);
        setIsLoading(false);
        onChangeLoading(false);
      }

      fetchCfGroups();
    }
  }, []);

  useEffect(() => {
    if(!field.options || !field.options?.length){
      if(!cf[field.id] && cfTypeGroups?.length === 1){
        onChange(field.id, cfTypeGroups[0].externalRefId, field.resetForm);
        setDisableSelect(true);
      }else{
        setDisableSelect(false);
      }
    }else{
      setDisableSelect(false);
    }
  }, [cfTypeGroups]);


  return (
    <>
      <div key={`${field.id}Wrapper`} className={`${clsx(classes.questionGroup, (field.options?.length > 0 ? classes.iconButtonsGroup : ''))} ${posting?.errors && posting?.errors[field.id] ? 'Mui-error' : ""}`}>
        <div className={clsx(classes.questionLabels, "singleLabel")}>
          <label className={clsx((field.required && !cf[field.id]) ? classes.requiredField : "","requiredField" )} key={`${field.id}fieldLabel`} style={field.subField ? {paddingLeft: "25px"} : {}}>
            {field.label}{" "}
            {field.required && <span className={classes.reqSymbol}>*</span>}
          </label>
          <span>:</span>
        </div>
        {
          isLoading
            ? <span key={`${field.id}loading`} className="loadingText">Loading...</span>
            : <>
              {field.options?.length > 0
                ? <div className={classes.mainQuestions}>
                  {readOnlyList?.includes(field.id)
                    ? (cf[field.id] ? field.options.find(o => o.value === cf[field.id])?.label : '')
                    : cfTypeGroups && cfTypeGroups.length > 0 && field.options.filter(f => { return cfTypeGroups.map(g => g.externalRefId).includes(f.value) }).map((d, i) => {
                      return (
                        <>
                          <div key={`${field.id}inputwrap${i}`} className={clsx(classes.activeHover, (d.value === cf[field.id] ? classes.activeRadio : ""))} style={{ backgroundColor: d.iconProp?.backgroundColor }}>
                            <input
                              type="radio"
                              name={field.id}
                              value={d.value || ''}
                              onChange={(e) => onChange(
                                e.target.name,
                                e.target.value,
                                field.resetForm
                              )}
                              checked={d.value === cf[field.id]}
                              id={`${field.id}${i}`}
                              key={`input${field.id}${i}`}
                              class="input-hidden" />
                            <label className="clearanceLabelName" htmlFor={`${field.id}${i}`} key={`label${field.id}${i}`}>
                              <img
                                key={`img${field.id}${i}`}
                                src={d.iconProp?.imgSrc}
                                alt={d.iconProp?.altText || d.label || "CF form type logo"} style={{ maxWidth: "150px" }} />
                              {d.label}
                            </label>
                          </div>
                        </>
                      )
                    })
                  }
                </div>
                : <>
                  {cfTypeGroups &&
                    readOnlyList?.includes(field.id)
                    ? (cf[field.id] ? <div className={classes.nameTextField}>{cfTypeGroups.find(o => o.externalRefId === cf[field.id])?.name } </div> : '')
                    : <div className={classes.questionGroupInner}>
                      <div>
                        {field.autocomplete?
                          <Autocomplete
                            name={field.id}
                            disableClearable
                            getOptionSelected={(option, value) => option?.key === value?.key}
                            getOptionLabel={(option) => option.name}
                            options={cfTypeGroups || []}
                            noOptionsText={"Not Available"}
                            value={cfTypeGroups?.find(d=>d.externalRefId === (cf[field.id] ?? field.defaultValue))}
                            openText={field.label ?? ''}
                            disabled={disableSelect || false}
                            renderInput={(params) => (
                              <TextField
                                {...params}  
                                variant="outlined"
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: (
                                    <React.Fragment>
                                      {params.InputProps.endAdornment}
                                    </React.Fragment>
                                  ),
                                }}
                              />
                            )}
                            onChange={(e, opt) => {
                              onChange(
                                field.id,
                                opt.externalRefId,
                                field.resetForm
                              );
                            }}
                          />:
                          <Select
                            name={field.id}
                            value={cf[field.id] || field.defaultValue || ''}
                            fullWidth
                            onChange={(e) => {
                              onChange(
                                e.target.name,
                                e.target.value,
                                field.resetForm
                              );
                            }}
                            inputProps={{
                              id: `${field.id}`,
                              "aria-labelledby": `${field.id}`,
                              "aria-label": `${field.label}`,
                            }}
                            title={field.label}
                            variant="outlined"
                            disabled={disableSelect || false}
                          >
                            {cfTypeGroups?.map((opt, i) => {
                              return (
                                <MenuItem
                                  key={i}
                                  value={opt.externalRefId}
                                >
                                  {opt.name}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        }

                        {posting.errors && posting.errors[field.id] && (
                          <span class="MuiFormHelperText-root MuiFormHelperText-contained Mui-error testasi">
                            {posting.errors[field.id]}
                          </span>
                        )}
                      </div>
                    </div>
                  }
                </>
              }

            </>
        }
      </div>
    </>
  );
}
